import React from 'react';

const Kanban = () => {
  return <div>Kanban</div>;
};

export default Kanban;
